import { Icon } from '@design-system/components/Icon/Icon';
import './DashboardLink.scss';
import { Typography } from '@design-system/components/Typography/Typography';
import { RoundedArrow } from '@assets/images/icons';
import { useNavigate } from 'react-router-dom';
type DashboardLinkProps = {
    color: 'sky' | 'turquoise' | 'apple-green' | 'green-water' | 'green';
    icon: React.ReactNode;
    label: string;
    url: string;
    isLocked?: boolean;
};
export const DashboardLink = ({ color, icon, label, url, isLocked }: DashboardLinkProps) => {
    const navigate = useNavigate();
    return (
        <div className={`dashboard-link ${isLocked ? 'locked' : ''}`} onClick={() => navigate(url)}>
            <div className="dashboard-link-icons">
                <Icon variant="surrounded" className="dashboard-link-icon" icon={icon} size={24} color={color} />
                <Icon className="dashboard-link-arrow" icon={<RoundedArrow />} size={24} color={'grey1'} />
            </div>
            <Typography intrinsic="span" color={'secondary'}>
                {label}
            </Typography>
        </div>
    );
};
